import { createBaseApi } from '../baseApi';

const api = createBaseApi('homeFeatureApi');

export const enhancedHomeFeatureApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getHomeFeature: builder.query({
            query: () => '/home-feature',
            keepUnusedDataFor: 600,
        }),
    }),
    overrideExisting: false,
});

export const { useGetHomeFeatureQuery } = enhancedHomeFeatureApi;
